import { IOutstandingOrdersFilter } from 'api/swaggerTypes';
import HyperLinkCell from './HyperLink';

const DATAGRIDCONSTANTS = {
    header: {
        SalesOrder: 152,
        Customer: 92,
        CustomerPO: 152,
        Entered: 87,
        Entity: 50,
        WH: 44,
        Status: 92,
        Category: 73,
        EarliestShip: 90,
        Expiry: 87,
        Description: 378,
        CustomerName: 332,
    }
};

export const SUBTITLE = 'You may recall one of the listed sales orders or create a new order for the customer’s P/O';

const ORDER_STATUS = {
    a: 'All',
    1: 'Incomplete',
    2: 'Active',
    3: 'On hold'
};

export const ParseOrderStatus = (status: IOutstandingOrdersFilter['OrderStatus']) => ORDER_STATUS?.[status] ?? '';

export const columns = [
    {
        dataField: 'SalesOrder',
        caption: 'Sales order',
        width: DATAGRIDCONSTANTS.header.SalesOrder,
        allowResizing: false,
        fixed: true,
        cellComponent: HyperLinkCell,
    },

    {
        dataField: 'CustomerIdDisplay',
        caption: 'Customer',
        width: DATAGRIDCONSTANTS.header.Customer,
        fixed: true,
        allowResizing: false,
    },
    {
        dataField: 'CustomerPurchaseOrder',
        caption: 'Customer P/O',
        width: DATAGRIDCONSTANTS.header.CustomerPO,
        allowSorting: false,
        allowEditing: false,
        allowResizing: true,
    },
    {
        dataField: 'EnterDate',
        caption: 'Entered',
        width: DATAGRIDCONSTANTS.header.Entered,
        allowResizing: true,
    },
    {
        dataField: 'SalesEntity',
        caption: 'Entity',
        width: DATAGRIDCONSTANTS.header.Entity,
        allowResizing: false,
    },
    {
        dataField: 'Warehouse',
        caption: 'W/H',
        width: DATAGRIDCONSTANTS.header.WH,
        allowResizing: true,
    },
    {
        dataField: 'OrderStatus',
        caption: 'Status',
        width: DATAGRIDCONSTANTS.header.Status,
        allowResizing: true,
        calculateCellValue: (d) => ParseOrderStatus(d.OrderStatus),
    },
    {
        dataField: 'Category',
        caption: 'Category',
        width: DATAGRIDCONSTANTS.header.Category,
        allowResizing: true,
    },
    {
        dataField: 'ShipDate',
        caption: 'Earliest ship',
        width: DATAGRIDCONSTANTS.header.EarliestShip,
        allowResizing: true,
    },
    {
        dataField: 'ExpiryDate',
        caption: 'Expiry',
        width: DATAGRIDCONSTANTS.header.Expiry,
        allowResizing: true,
    },
    {
        dataField: 'Description',
        caption: 'Description',
        width: DATAGRIDCONSTANTS.header.Description,
        allowResizing: true,
    },
    {
        dataField: 'CustomerName',
        caption: 'Customer name',
        width: DATAGRIDCONSTANTS.header.CustomerName,
        allowResizing: true,
    },
];
